export default __webpack_public_path__ + "static/media/Fatal Hyperborean Hierophant Gem.6e39c979.jpg";